"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMyAccountUrlTemplate = exports.MyAccountExternalPageId = void 0;
var PageComponentId_1 = require("../PageComponentId");
var appDefIds_1 = require("../appDefIds");
var MyAccountExternalPageId;
(function (MyAccountExternalPageId) {
    MyAccountExternalPageId["SiteSettings"] = "site-settings";
    MyAccountExternalPageId["AddApp"] = "add-app";
    MyAccountExternalPageId["ManagePremium"] = "manage-premium";
    MyAccountExternalPageId["Contributors"] = "contributors";
    MyAccountExternalPageId["myAccount"] = "myAccount";
})(MyAccountExternalPageId = exports.MyAccountExternalPageId || (exports.MyAccountExternalPageId = {}));
//DEPRECATED by specs.wos.DeprecateRedirectToMyAccount!
function getMyAccountUrlTemplate(metaSiteId, pageComponentId) {
    var myAccountAppBaseUrl = "https://www.wix.com/my-account/sites/" + metaSiteId;
    switch (pageComponentId) {
        case PageComponentId_1.PageComponentId.Engage:
        case appDefIds_1.appDefIds.engage:
            return {
                baseUrl: function (ctx) { return myAccountAppBaseUrl + "/inbox/" + (ctx.contactId ? ctx.contactId : ''); },
                query: { referralInfo: function (ctx) { return ctx.referrer; } }
            };
        case PageComponentId_1.PageComponentId.Invoices:
        case appDefIds_1.appDefIds.invoices:
            return {
                baseUrl: function (ctx) { return myAccountAppBaseUrl + "/quotes/"; },
                query: { referralInfo: function (ctx) { return ctx.referrer; } }
            };
        case PageComponentId_1.PageComponentId.Contacts:
        case appDefIds_1.appDefIds.contacts:
            return {
                baseUrl: function (ctx) { return myAccountAppBaseUrl + "/contacts/" + (ctx.contactId ? ctx.contactId : ''); },
                query: { referralInfo: function (ctx) { return ctx.referrer; }, flow: '=', tag: '=' }
            };
        case PageComponentId_1.PageComponentId.Triggers:
        case appDefIds_1.appDefIds.triggers:
            return {
                baseUrl: function (ctx) { return myAccountAppBaseUrl + "/triggers/" + (ctx.triggerId ? "wizard/" + ctx.triggerId : ''); },
                query: {
                    referralInfo: function (ctx) { return ctx.referrer; },
                    step: function (ctx) { return ctx.triggerId ? ctx.step : undefined; },
                    wizardFullScreen: function (ctx) { return ctx.triggerId ? ctx.wizardFullScreen : undefined; }
                }
            };
        case PageComponentId_1.PageComponentId.Seo:
        case appDefIds_1.appDefIds.seoWizard:
            return {
                baseUrl: function (ctx) { return myAccountAppBaseUrl + "/seo/"; },
                query: { referralInfo: function (ctx) { return ctx.referrer; } }
            };
        case PageComponentId_1.PageComponentId.Blog:
        case appDefIds_1.appDefIds.blog:
            return {
                baseUrl: function (ctx) { return myAccountAppBaseUrl + "/simple-app/"; },
                query: { referralInfo: function (ctx) { return ctx.referrer; }, app: 'blog' }
            };
        case MyAccountExternalPageId.myAccount:
            return {
                baseUrl: function () { return myAccountAppBaseUrl; }
            };
        case MyAccountExternalPageId.SiteSettings:
            return {
                baseUrl: function (ctx) { return myAccountAppBaseUrl + "/site-settings/"; },
                query: { referralInfo: function (ctx) { return ctx.referrer; } }
            };
        case MyAccountExternalPageId.Contributors:
            return {
                baseUrl: function (ctx) { return myAccountAppBaseUrl + "/site-settings/authorization"; },
                query: { referralInfo: function (ctx) { return ctx.referrer; } }
            };
        case MyAccountExternalPageId.AddApp:
            return {
                baseUrl: function (ctx) { return myAccountAppBaseUrl + "/apps/"; },
                query: { referralInfo: function (ctx) { return ctx.referrer; } }
            };
        case MyAccountExternalPageId.ManagePremium:
            return {
                baseUrl: function (ctx) { return myAccountAppBaseUrl + "/manage-premium/"; },
                query: { referralInfo: function (ctx) { return ctx.referrer; } }
            };
        default:
            return null;
    }
}
exports.getMyAccountUrlTemplate = getMyAccountUrlTemplate;
//# sourceMappingURL=MyAccountUrlTemplates.js.map